import { useWrapAsync } from "@paroicms/front-app-log";
import { useEffect, useState } from "react";
import { fetchSettings } from "../../../../api/application/settings";
import { fetchDashboardStatistics } from "../../../../api/application/statistics";
import type { RequestError } from "../../../../api/infrastructure/statistics.api";
import type { Statistics } from "../../../../api/infrastructure/statistics.formatter";
import { apiRequestWrapper } from "../../../../api/shared/http-client";
import { appLog } from "../../../../context";
import { useAppStore } from "../../../../store/app.store";
import Navbar from "../../parts/Navbar/Navbar";
import NoDataMessage from "../../utils/NoDataMessage/NoDataMessage";
import Spinner from "../../utils/Spinner/Spinner";
import StatisticsPart from "../StatisticsScreen/StatisticsPart/StatisticsPart";

export default function HomeScreen() {
  const wrapAsync = useWrapAsync();
  const settings = useAppStore((state) => state.settings);
  const setSettings = useAppStore((state) => state.setSettings);
  const [statistics, setStatistics] = useState<Statistics | RequestError>();

  useEffect(
    wrapAsync(async () => {
      if (settings) return;
      await apiRequestWrapper(
        async () => {
          setSettings(await fetchSettings());
        },
        { handle404: true },
      );
    }),
    [settings],
  );
  useEffect(
    wrapAsync(async () => {
      try {
        setStatistics(await fetchDashboardStatistics());
      } catch (error) {
        const message = error instanceof Error ? error.message : "Une erreur est survenue";
        appLog.error(error);
        setStatistics({
          error: message,
        });
      }
    }),
    [],
  );

  if (!settings || !statistics) return <Spinner />;
  if (!settings.defaultReferenceId || !settings.defaultTableId) {
    return <NoDataMessage message="Aucun référentiel par défaut défini" />;
  }
  return (
    <div>
      <Navbar pageTitle="" />

      <div className="Container">
        <div className="Container-content">
          <StatisticsPart
            statistics={statistics}
            defaultReferenceId={settings.defaultReferenceId}
            defaultTableId={settings.defaultTableId}
          />
        </div>
      </div>
    </div>
  );
}
